// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Button,
//   Grid,
//   Paper,
//   TextField,
//   MenuItem,
//   Typography,
//   FormControl,
//   FormControlLabel,
//   Checkbox,
//   FormHelperText,
//   InputLabel,
//   Select,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import useAuthStore from "../../../Zustand/Store/useAuthStore";
// import { MAIN_URL } from "../../../Configurations/Urls";
// import axios from "axios";
// import useEmployeeDataStore from "../../../Zustand/Store/useEmployeeDataStore";

// const formatDate = (dateStr) => {
//   if (!dateStr) return "";
//   return typeof dateStr === "string" && dateStr.includes("T")
//     ? dateStr.split("T")[0]
//     : dateStr;
// };

// function PersonIdentificationForm({ mode }) {
//   const { userData } = useAuthStore();
//   const org = userData?.organization;
//   const {
//     setIdentificationData,
//     Identification,
//     IdentificationErrors,
//     addIdentification,
//     removeIdentification,
//   } = useEmployeeDataStore();

//   const [identificationTypes, setIdentificationTypes] = useState([]);
//   const [expanded, setExpanded] = useState("Person Identification 1");

//   useEffect(() => {
//     if (org?.organization_id) {
//       axios
//         .get(
//           `${MAIN_URL}/api/organizations/${org.organization_id}/person-identification-type`,
//           {
//             headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//           }
//         )
//         .then((res) => {
//           setIdentificationTypes(res?.data?.personIdentificationTypes ?? []);
//         })
//         .catch(() => setIdentificationTypes([]));
//     }
//   }, [org?.organization_id]);

//   const handleChangeAccoridan = (panelId) => (event, isExpanded) => {
//     setExpanded(isExpanded ? panelId : "");
//   };

//   const handleChange = (e, idx) => {
//     const { name, value } = e.target;
//     setIdentificationData(name, value, idx);
//   };

//   const handleCheckboxChange = (e, idx) => {
//     const { name, checked } = e.target;
//     setIdentificationData(name, checked, idx);
//   };

//   return (
//     <Box px={4}>
//       <Box>
//         {Identification?.map((item, id) => ({
//           name: `Person Identification ${id + 1}`,
//           mainData: item,
//         }))?.map((section, idx) => (
//           <Accordion
//             sx={{ mb: 2 }}
//             key={section.name}
//             expanded={expanded === section.name}
//             onChange={handleChangeAccoridan(section.name)}
//           >
//             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   width: "100%",
//                 }}
//               >
//                 <Typography
//                   variant="h6"
//                   sx={{ fontSize: "15px", fontWeight: "bold" }}
//                 >
//                   {section.name}
//                 </Typography>
//                 {idx !== 0 && (
//                   <DeleteOutlineIcon
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       removeIdentification(idx);
//                     }}
//                     sx={{ color: "error.main", ml: 2 }}
//                   />
//                 )}
//               </Box>
//             </AccordionSummary>
//             <AccordionDetails>
//               {expanded === section.name && (
//                 <Paper elevation={4} sx={{ p: 3 }}>
//                   <Grid container spacing={2}>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "center",
//                         gap: 2,
//                         width: "100%",
//                       }}
//                     >
//                       <FormControl
//                         disabled={mode === "view"}
//                         fullWidth
//                         error={
//                           !!IdentificationErrors?.[idx]
//                             ?.organization_person_identification_type_id
//                         }
//                       >
//                         <InputLabel id="identification-type-label">
//                           Identification Type
//                         </InputLabel>
//                         <Select
//                           disabled={mode === "view"}
//                           labelId="identification-type-label"
//                           id="organization_person_identification_type_id"
//                           name="organization_person_identification_type_id"
//                           value={
//                             section?.mainData
//                               ?.organization_person_identification_type_id ||
//                             ""
//                           }
//                           onChange={(e) => handleChange(e, idx)}
//                           label="Identification Type"
//                         >
//                           {identificationTypes.map((opt) => (
//                             <MenuItem
//                               key={
//                                 opt.organization_person_identification_type_id
//                               }
//                               value={
//                                 opt.organization_person_identification_type_id
//                               }
//                             >
//                               {opt.identification_type_name}
//                             </MenuItem>
//                           ))}
//                         </Select>
//                         {IdentificationErrors?.[idx]
//                           ?.organization_person_identification_type_id && (
//                           <FormHelperText>
//                             {
//                               IdentificationErrors?.[idx]
//                                 ?.organization_person_identification_type_id
//                             }
//                           </FormHelperText>
//                         )}
//                       </FormControl>

//                       <TextField
//                         disabled={mode === "view"}
//                         fullWidth
//                         label="Identification Number"
//                         name="identification_number"
//                         value={section?.mainData?.identification_number || ""}
//                         onChange={(e) => handleChange(e, idx)}
//                         error={!!IdentificationErrors?.[idx]?.identification_number}
//                         helperText={
//                           IdentificationErrors?.[idx]?.identification_number
//                         }
//                         inputProps={{ maxLength: 100 }}
//                       />
//                     </Box>

//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "center",
//                         gap: 2,
//                         width: "100%",
//                       }}
//                     >
//                       <TextField
//                         disabled={mode === "view"}
//                         fullWidth
//                         label="Issuing Authority"
//                         name="issuing_authority"
//                         value={
//                           section?.mainData?.issuing_authority || ""
//                         }
//                         onChange={(e) => handleChange(e, idx)}
//                         error={
//                           !!IdentificationErrors?.[idx]?.issuing_authority
//                         }
//                         helperText={
//                           IdentificationErrors?.[idx]?.issuing_authority
//                         }
//                         inputProps={{ maxLength: 100 }}
//                       />

//                       <TextField
//                         disabled={mode === "view"}
//                         fullWidth
//                         label="Issue Date"
//                         type="date"
//                         name="effective_date"
//                         value={
//                           formatDate(section?.mainData?.effective_date) || ""
//                         }
//                         onChange={(e) => handleChange(e, idx)}
//                         InputLabelProps={{ shrink: true }}
//                         error={
//                           !!IdentificationErrors?.[idx]?.effective_date
//                         }
//                         helperText={
//                           IdentificationErrors?.[idx]?.effective_date
//                         }
//                       />

//                       <TextField
//                         disabled={mode === "view"}
//                         fullWidth
//                         label="Expiry Date"
//                         type="date"
//                         name="valid_till"
//                         value={
//                           formatDate(section?.mainData?.valid_till) || ""
//                         }
//                         onChange={(e) => handleChange(e, idx)}
//                         InputLabelProps={{ shrink: true }}
//                         error={!!IdentificationErrors?.[idx]?.valid_till}
//                         helperText={
//                           IdentificationErrors?.[idx]?.valid_till
//                         }
//                       />
//                     </Box>

                  
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "center",
//                         gap: 2,
//                         width: "100%",
//                       }}
//                     >
//                       <TextField
//                         disabled={mode === "view"}
//                         fullWidth
//                         label="Verified By"
//                         name="verified_by"
//                         value={section?.mainData?.verified_by || ""}
//                         onChange={(e) => handleChange(e, idx)}
//                         error={!!IdentificationErrors?.[idx]?.verified_by}
//                         helperText={
//                           IdentificationErrors?.[idx]?.verified_by
//                         }
//                         inputProps={{ maxLength: 100 }}
//                       />

//                       <TextField
//                         disabled={mode === "view"}
//                         fullWidth
//                         label="Verified At"
//                         type="date"
//                         name="verified_at"
//                         value={
//                           formatDate(section?.mainData?.verified_at) || ""
//                         }
//                         onChange={(e) => handleChange(e, idx)}
//                         InputLabelProps={{ shrink: true }}
//                         error={!!IdentificationErrors?.[idx]?.verified_at}
//                         helperText={
//                           IdentificationErrors?.[idx]?.verified_at
//                         }
//                       />
                  

//                       <TextField
//                         disabled={mode === "view"}
//                         fullWidth
//                         label="Person Document"
//                         name="person_document_id"
//                         type="number"
//                         value={
//                           section?.mainData?.person_document_id ?? ""
//                         }
//                         onChange={(e) => handleChange(e, idx)}
//                         error={
//                           !!IdentificationErrors?.[idx]?.person_document_id
//                         }
//                         helperText={
//                           IdentificationErrors?.[idx]?.person_document_id
//                         }
//                         inputProps={{ min: 0 }}
//                       />
//                     </Box>

//                     <TextField
//                       disabled={mode === "view"}
//                       fullWidth
//                       multiline
//                       rows={3}
//                       label="Remarks"
//                       name="remarks"
//                       value={section?.mainData?.remarks || ""}
//                       onChange={(e) => handleChange(e, idx)}
//                       error={!!IdentificationErrors?.[idx]?.remarks}
//                       helperText={IdentificationErrors?.[idx]?.remarks}
//                       inputProps={{ maxLength: 255 }}
//                       sx={{ mt: 2 }}
//                     />
//                   </Grid>
//                 </Paper>
//               )}
//             </AccordionDetails>
//           </Accordion>
//         ))}

//         <Button
//           disabled={mode === "view"}
//           variant="contained"
//           style={{ marginTop: 9 }}
//           onClick={() => {
//             setExpanded(`Person Identification ${Identification?.length + 1}`);
//             addIdentification();
//           }}
//         >
//           Add More
//         </Button>
//       </Box>
//     </Box>
//   );
// }

// export default PersonIdentificationForm;




import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  MenuItem,
  Typography,
  FormControl,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  InputLabel,
  Select,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import { MAIN_URL } from "../../../Configurations/Urls";
import axios from "axios";
import useEmployeeDataStore from "../../../Zustand/Store/useEmployeeDataStore";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  return typeof dateStr === "string" && dateStr.includes("T")
    ? dateStr.split("T")[0]
    : dateStr;
};

function PersonIdentificationForm({ mode }) {
  const { userData } = useAuthStore();
  const org = userData?.organization;
  const {
    setIdentificationData,
    Identification,
    IdentificationErrors,
    addIdentification,
    removeIdentification,
  } = useEmployeeDataStore();

  const [identificationTypes, setIdentificationTypes] = useState([]);
  const [expanded, setExpanded] = useState("Person Identification 1");
  
  // Store files separately - one for each identification (for preview purposes)
  const [documentUrls, setDocumentUrls] = useState({});

  useEffect(() => {
    if (org?.organization_id) {
      axios
        .get(
          `${MAIN_URL}/api/organizations/${org.organization_id}/person-identification-type`,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          }
        )
        .then((res) => {
          setIdentificationTypes(res?.data?.personIdentificationTypes ?? []);
        })
        .catch(() => setIdentificationTypes([]));
    }
  }, [org?.organization_id]);

  const handleChangeAccoridan = (panelId) => (event, isExpanded) => {
    setExpanded(isExpanded ? panelId : "");
  };

  const handleChange = (e, idx) => {
    const { name, value } = e.target;
    setIdentificationData(name, value, idx);
  };

  const handleCheckboxChange = (e, idx) => {
    const { name, checked } = e.target;
    setIdentificationData(name, checked, idx);
  };

  const handleFileChange = (e, idx) => {
    const selectedFile = e?.target?.files[0];
    if (selectedFile) {
      // Create preview URL for local display
      const sizeInKB = (selectedFile.size / 1024).toFixed(2);
      
      if (sizeInKB > 10240) {
        setIdentificationData("person_document_file", null, idx);
        setIdentificationData("person_document_size_kb", sizeInKB, idx);
        return;
      }

      const url = URL.createObjectURL(selectedFile);
      setDocumentUrls((prev) => ({ ...prev, [idx]: url }));
      
      // Store the actual File object in Zustand
      setIdentificationData("person_document_file", selectedFile, idx);
      setIdentificationData("person_document_size_kb", sizeInKB, idx);
    }
  };

  const handlePreview = (idx) => {
    const file = Identification[idx]?.person_document_file;
    const previewUrl = documentUrls[idx];

    // Case 1: Freshly uploaded file (File object, with a preview URL we generated)
    if (file instanceof File && previewUrl) {
      const name = file?.name || "document";
      const fileExtension = name.split(".").pop().toLowerCase();

      if (
        ["pdf", "jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(
          fileExtension
        )
      ) {
        window.open(previewUrl, "_blank");
      } else {
        const link = document.createElement("a");
        link.href = previewUrl;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      return;
    }

    // Case 2: Already stored file (string URL from DB)
    if (typeof file === "string" && file) {
      window.open(file, "_blank");
      return;
    }
  };

  const handleRemoveFile = (idx) => {
    // Clean up object URL to prevent memory leaks
    if (documentUrls[idx]) {
      URL.revokeObjectURL(documentUrls[idx]);
    }

    setDocumentUrls((prev) => {
      const newUrls = { ...prev };
      delete newUrls[idx];
      return newUrls;
    });

    // Clear the file in Zustand
    setIdentificationData("person_document_file", "", idx);
    setIdentificationData("person_document_size_kb", "", idx);
  };

  const handleRemoveIdentification = (idx) => {
    // Clean up file URL before removing identification
    if (documentUrls[idx]) {
      URL.revokeObjectURL(documentUrls[idx]);
    }

    // Remove from URL state
    setDocumentUrls((prev) => {
      const newUrls = { ...prev };
      delete newUrls[idx];
      return newUrls;
    });

    // Remove from Zustand
    removeIdentification(idx);
  };

  // Cleanup URLs on unmount
  useEffect(() => {
    return () => {
      Object.values(documentUrls).forEach((url) => {
        if (url) URL.revokeObjectURL(url);
      });
    };
  }, []);

  return (
    <Box px={{ xs: 1, sm: 2, md: 4 }}>
      <Box>
        {Identification?.map((item, id) => ({
          name: `Person Identification ${id + 1}`,
          mainData: item,
        }))?.map((section, idx) => (
          <Accordion
            sx={{ mb: 2 }}
            key={section.name}
            expanded={expanded === section.name}
            onChange={handleChangeAccoridan(section.name)}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontSize: "15px", fontWeight: "bold" }}
                >
                  {section.name}
                </Typography>
                {idx !== 0 && (
                  <DeleteOutlineIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveIdentification(idx);
                    }}
                    sx={{ 
                      color: "error.main", 
                      ml: 2,
                      cursor: "pointer",
                      "&:hover": { opacity: 0.7 },
                    }}
                  />
                )}
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              {expanded === section.name && (
                <Paper elevation={4} sx={{ p: { xs: 2, md: 3 } }}>
                  <Grid container spacing={2}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "center",
                        gap: 2,
                        width: "100%",
                      }}
                    >
                      <FormControl
                        disabled={mode === "view"}
                        fullWidth
                        error={
                          !!IdentificationErrors?.[idx]
                            ?.organization_person_identification_type_id
                        }
                      >
                        <InputLabel id="identification-type-label">
                          Identification Type
                        </InputLabel>
                        <Select
                          disabled={mode === "view"}
                          labelId="identification-type-label"
                          id="organization_person_identification_type_id"
                          name="organization_person_identification_type_id"
                          value={
                            section?.mainData
                              ?.organization_person_identification_type_id ||
                            ""
                          }
                          onChange={(e) => handleChange(e, idx)}
                          label="Identification Type"
                        >
                          {identificationTypes.map((opt) => (
                            <MenuItem
                              key={
                                opt.organization_person_identification_type_id
                              }
                              value={
                                opt.organization_person_identification_type_id
                              }
                            >
                              {opt.identification_type_name}
                            </MenuItem>
                          ))}
                        </Select>
                        {IdentificationErrors?.[idx]
                          ?.organization_person_identification_type_id && (
                          <FormHelperText>
                            {
                              IdentificationErrors?.[idx]
                                ?.organization_person_identification_type_id
                            }
                          </FormHelperText>
                        )}
                      </FormControl>

                      <TextField
                        disabled={mode === "view"}
                        fullWidth
                        label="Identification Number"
                        name="identification_number"
                        value={section?.mainData?.identification_number || ""}
                        onChange={(e) => handleChange(e, idx)}
                        error={!!IdentificationErrors?.[idx]?.identification_number}
                        helperText={
                          IdentificationErrors?.[idx]?.identification_number
                        }
                        inputProps={{ maxLength: 100 }}
                      />
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "center",
                        gap: 2,
                        width: "100%",
                      }}
                    >
                      <TextField
                        disabled={mode === "view"}
                        fullWidth
                        label="Issuing Authority"
                        name="issuing_authority"
                        value={
                          section?.mainData?.issuing_authority || ""
                        }
                        onChange={(e) => handleChange(e, idx)}
                        error={
                          !!IdentificationErrors?.[idx]?.issuing_authority
                        }
                        helperText={
                          IdentificationErrors?.[idx]?.issuing_authority
                        }
                        inputProps={{ maxLength: 100 }}
                      />

                      <TextField
                        disabled={mode === "view"}
                        fullWidth
                        label="Issue Date"
                        type="date"
                        name="effective_date"
                        value={
                          formatDate(section?.mainData?.effective_date) || ""
                        }
                        onChange={(e) => handleChange(e, idx)}
                        InputLabelProps={{ shrink: true }}
                        error={
                          !!IdentificationErrors?.[idx]?.effective_date
                        }
                        helperText={
                          IdentificationErrors?.[idx]?.effective_date
                        }
                      />

                      <TextField
                        disabled={mode === "view"}
                        fullWidth
                        label="Expiry Date"
                        type="date"
                        name="valid_till"
                        value={
                          formatDate(section?.mainData?.valid_till) || ""
                        }
                        onChange={(e) => handleChange(e, idx)}
                        InputLabelProps={{ shrink: true }}
                        error={!!IdentificationErrors?.[idx]?.valid_till}
                        helperText={
                          IdentificationErrors?.[idx]?.valid_till
                        }
                      />
                    </Box>

                  
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        justifyContent: "center",
                        gap: 2,
                        width: "100%",
                      }}
                    >
                      <TextField
                        disabled={mode === "view"}
                        fullWidth
                        label="Verified By"
                        name="verified_by"
                        value={section?.mainData?.verified_by || ""}
                        onChange={(e) => handleChange(e, idx)}
                        error={!!IdentificationErrors?.[idx]?.verified_by}
                        helperText={
                          IdentificationErrors?.[idx]?.verified_by
                        }
                        inputProps={{ maxLength: 100 }}
                      />

                      <TextField
                        disabled={mode === "view"}
                        fullWidth
                        label="Verified At"
                        type="date"
                        name="verified_at"
                        value={
                          formatDate(section?.mainData?.verified_at) || ""
                        }
                        onChange={(e) => handleChange(e, idx)}
                        InputLabelProps={{ shrink: true }}
                        error={!!IdentificationErrors?.[idx]?.verified_at}
                        helperText={
                          IdentificationErrors?.[idx]?.verified_at
                        }
                      />
                    </Box>

                    {/* File Picker - Single Line */}
                    <Grid item xs={12}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Button
                          disabled={mode === "view"}
                          variant="contained"
                          component="label"
                          sx={{
                            textTransform: "none",
                            fontWeight: 500,
                            py: 1,
                            borderRadius: 2,
                            flexGrow: 1,
                            backgroundColor: "#9e9e9e", // grey
                            color: "#fff", // white text
                            "&:hover": {
                              backgroundColor: "#7d7d7d", // darker grey on hover
                            },
                          }}
                        >
                          {section?.mainData?.person_document_file
                            ? "Change Document"
                            : "Upload Document"}
                          <input
                            type="file"
                            hidden
                            onChange={(e) => handleFileChange(e, idx)}
                            accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                          />
                        </Button>

                        {section?.mainData?.person_document_file && (
                          <>
                            <IconButton
                              size="small"
                              onClick={() => handlePreview(idx)}
                              sx={{
                                backgroundColor: "#e3f2fd",
                                color: "#1976d2",
                                "&:hover": { backgroundColor: "#bbdefb" },
                                border: "1px solid #ddd",
                                width: 32,
                                height: 32,
                              }}
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>

                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleRemoveFile(idx)}
                              sx={{
                                backgroundColor: "#f5f5f5",
                                "&:hover": {
                                  backgroundColor: "#e57373",
                                  color: "#fff",
                                },
                                border: "1px solid #ddd",
                                width: 32,
                                height: 32,
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </>
                        )}
                      </Box>

                      {(section?.mainData?.person_document_file || section?.mainData?.person_document_name) && (
                        <Typography
                          variant="body2"
                          sx={{
                            color:
                              section?.mainData?.person_document_size_kb > 10240
                                ? "error.main"
                                : "#2e7d32",
                            fontWeight: 500,
                            mt: 0.5,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          Selected:{" "}
                          {section?.mainData?.person_document_file?.name ||
                            section?.mainData?.person_document_name ||
                            "File"}{" "}
                          {section?.mainData?.person_document_size_kb
                            ? `- ${section?.mainData?.person_document_size_kb} KB`
                            : ""}
                          {section?.mainData?.person_document_size_kb > 10240 &&
                            " (File too large! Max 10 MB)"}
                        </Typography>
                      )}
                    </Grid>

                    <TextField
                      disabled={mode === "view"}
                      fullWidth
                      multiline
                      rows={3}
                      label="Remarks"
                      name="remarks"
                      value={section?.mainData?.remarks || ""}
                      onChange={(e) => handleChange(e, idx)}
                      error={!!IdentificationErrors?.[idx]?.remarks}
                      helperText={IdentificationErrors?.[idx]?.remarks}
                      inputProps={{ maxLength: 255 }}
                      sx={{ mt: 2 }}
                    />
                  </Grid>
                </Paper>
              )}
            </AccordionDetails>
          </Accordion>
        ))}

        <Button
          disabled={mode === "view"}
          variant="contained"
          style={{ marginTop: 9 }}
          onClick={() => {
            setExpanded(`Person Identification ${Identification?.length + 1}`);
            addIdentification();
          }}
        >
          Add More
        </Button>
      </Box>
    </Box>
  );
}

export default PersonIdentificationForm;